import { ActionRowProps } from '../../components/kopiliot-list/type'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { ComparisonTsValue } from '../../shared/models/telemetry/telemetry.model'
import dayjs from 'dayjs'

const getColumnsForTableLatestTelemetries = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<{ key: string } & ComparisonTsValue>()
  const columns: ColumnDef<{ key: string } & ComparisonTsValue, string>[] = [
    columnHelper.accessor((row) => row.key, {
      id: 'key',
      cell: (info) => info.getValue(),
      header: () => 'Clé',
    }),
    columnHelper.display({
      id: 'ts',
      header: () => 'Date',
      enableSorting: true,
      cell: (props) => {
        const ts = props.row.original?.current?.ts

        return ts ? (
          <span>{dayjs(ts).format('DD/MM/YYYY HH:mm:ss.SSS')}</span>
        ) : (
          ''
        )
      },
    }),
    columnHelper.display({
      id: 'value',
      header: () => 'Valeur',
      enableSorting: true,
      cell: (props) => {
        let value = props.row.original.current?.value
        if (typeof value === 'object') {
          value = JSON.stringify(value)
        }
        return <span>{value.toString()}</span>
      },
    }),
    columnHelper.display({
      id: 'type',
      header: () => 'Type',
      enableSorting: true,
      cell: (props) => {
        let value = props.row.original.current?.type
        return <span>{value}</span>
      },
    }),
    columnHelper.display({
      id: 'previousTs',
      header: () => 'Date précédente',
      enableSorting: true,
      cell: (props) => {
        const ts = props.row.original?.previous?.ts

        return ts ? (
          <span>{dayjs(ts).format('DD/MM/YYYY HH:mm:ss.SSS')}</span>
        ) : (
          ''
        )
      },
    }),
    columnHelper.display({
      id: 'previousValue',
      header: () => 'Valeur',
      enableSorting: true,
      cell: (props) => {
        let value = props.row.original.previous?.value
        if (typeof value === 'object') {
          value = JSON.stringify(value)
        }
        return value ? <span>{value.toString()}</span> : ''
      },
    }),
    columnHelper.display({
      id: 'previousType',
      header: () => 'Type',
      enableSorting: true,
      cell: (props) => {
        let value = props.row.original.previous?.type
        return value ? <span>{value}</span> : ''
      },
    }),
  ]
  return columns
}

export { getColumnsForTableLatestTelemetries }
